/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

export const NEGOTIABLE_QUOTE_LIST_FRAGMENT = /* GraphQL */ `
  fragment NegotiableQuoteListFragment on NegotiableQuote {
    uid
    name
    created_at
    updated_at
    status
    buyer {
      firstname
      lastname
    }
    template_name
    prices {
      grand_total {
        value
        currency
      }
    }
    history {
      change_type
      changes {
        statuses {
          changes {
            new_status
            old_status
          }
        }
      }
    }
  }
`;
